export const SHOW_MESSAGE = 'SHOW_MESSAGE'

export const LOCK_SCREEN = 'LOCK_SCREEN'
export const UNLOCK_SCREEN = 'UNLOCK_SCREEN'

export const SET_ACTIVE_MODULE = 'SET_ACTIVE_MODULE'
export const MODULE_CHANGING_USING_MAIN_MENU = 'MODULE_CHANGING_USING_MAIN_MENU'

// to add the connection to list of saved connection
export const PUSH_FILE_CONNECTIONS_TO_LIST_OF_CONNECTIONS = 'PUSH_FILE_CONNECTIONS_TO_LIST_OF_CONNECTIONS'
export const ADD_CONNECTION_TO_LIST_OF_CONNECTIONS = 'ADD_CONNECTION_TO_LIST_OF_CONNECTIONS'
export const EDIT_CONNECTION_IN_LIST_OF_CONNECTIONS = 'EDIT_CONNECTION_IN_LIST_OF_CONNECTIONS'
export const DELETE_CONNECTION_FROM_LIST_OF_CONNECTIONS = 'DELETE_CONNECTION_FROM_LIST_OF_CONNECTIONS'

export const SET_LOGGED_IN_USER_INFORMATION = 'SET_LOGGED_IN_USER_INFORMATION'
export const SET_SCREEN_RIGHTS = 'SET_SCREEN_RIGHTS'
export const LOGGED_IN = 'LOGGED_IN'
export const SET_USERS_TYPE = 'SET_USERS_TYPE'
export const SET_LOGGED_IN_CONNECTION_OBJECT = 'SET_LOGGED_IN_CONNECTION_OBJECT'
export const SET_LEERLING_ID = 'SET_LEERLING_ID'
export const SET_EXTERNAL_LINK_FOR_EVALUATION = 'SET_EXTERNAL_LINK_FOR_EVALUATION'
export const IS_HEVERLEE_USER = 'IS_HEVERLEE_USER'



export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_MENUBAR_ITEMS = 'SET_MENUBAR_ITEMS'
export const SET_TEXT_BUTTONS_ON_MENUBAR = 'SET_TEXT_BUTTONS_ON_MENUBAR'
export const SET_TITLE_OF_MENUBAR = 'SET_TITLE_OF_MENUBAR'
export const SET_MENUBAR_RIGHT_SIDE_MENU_ITEMS = 'SET_MENUBAR_RIGHT_SIDE_MENU_ITEMS'
export const SET_MENUBAR_RIGHT_SIDE_MENU_VISIBLE = 'SET_MENUBAR_RIGHT_SIDE_MENU_VISIBLE'
export const TOGGLE_MENU = 'TOGGLE_MENU'

export const SET_VERSIENUMMER = 'SET_VERSIENUMMER'

export const SET_PROJECT_NAAM = 'SET_PROJECT_NAAM'

export const INITIALIZE_DROPDOWN_PAGE = 'INITIALIZE_DROPDOWN_PAGE'
export const UPDATE_LIST_OF_ITEMS_OF_DROPDOWN = 'UPDATE_LIST_OF_ITEMS_OF_DROPDOWN'

export const UNLOCK_LOGIN_PROCEDURE = 'UNLOCK_LOGIN_PROCEDURE'
export const LOCK_LOGIN_PROCEDURE = 'LOCK_LOGIN_PROCEDURE'

export const SET_STATE_TO_INITIAL_VALUES = 'SET_STATE_TO_INITIAL_VALUES'
export const LOGGED_OUT_ONCE = 'LOGGED_OUT_ONCE'

export const CLOSE_DIALOG = 'CLOSE_DIALOG'
export const LAST_ACTIVE_DIALOG = 'LAST_ACTIVE_DIALOG'

export const SET_LOGIN_REDIRECTED = 'SET_LOGIN_REDIRECTED'

export const SET_CURRENT_CONNECTION_API = 'SET_CURRENT_CONNECTION_API'



